import { render, staticRenderFns } from "./Announcement.vue?vue&type=template&id=cefe3138&scoped=true"
import script from "./Announcement.vue?vue&type=script&lang=ts"
export * from "./Announcement.vue?vue&type=script&lang=ts"
import style0 from "./Announcement.vue?vue&type=style&index=0&id=cefe3138&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cefe3138",
  null
  
)

export default component.exports